import React from "react";

// The signature motif — reused in nav, hero, and footer.
export default function Sprig({ width = 46, color = "currentColor", style }) {
  return (
    <svg
      width={width}
      viewBox="0 0 60 28"
      fill="none"
      style={style}
      aria-hidden="true"
    >
      <path d="M30 26 C30 18 30 10 30 3" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
      <path d="M30 9 C22 7 16 9 11 14 C19 15 25 14 30 9 Z" fill={color} opacity=".55" />
      <path d="M30 9 C38 7 44 9 49 14 C41 15 35 14 30 9 Z" fill={color} opacity=".55" />
      <path d="M30 16 C24 15 19 16 15 20 C21 21 26 20 30 16 Z" fill={color} opacity=".4" />
      <path d="M30 16 C36 15 41 16 45 20 C39 21 34 20 30 16 Z" fill={color} opacity=".4" />
    </svg>
  );
}
